import { PART_TYPES, SHIRT_COLOR_TYPES } from '../faceParts/data/enums'
import { colorMap } from '../helpers/colorHelper'
import { PART_ACTIONS } from '../faceParts/data/constants'

const defaultColors = Object.freeze({
  skin: colorMap[PART_TYPES.FACE_SHAPE]['#EBECEC'].colorKey,
  hair: colorMap[PART_TYPES.HAIR]['#000000'].colorKey,
  eye: colorMap[PART_TYPES.EYES]['#99A092'].colorKey,
  mouth: colorMap[PART_TYPES.MOUTH]['#535659'].colorKey,
  jewelry: colorMap[PART_TYPES.JEWELRY]['#FFDC2E'].colorKey,
  shirt: {
    main: colorMap[PART_TYPES.SHIRT]['#156599'].colorKey,
    second: colorMap[PART_TYPES.SHIRT]['#2888C6'].colorKey,
  },
})

const initialValues = Object.freeze({
  partsSections: [],
  selectedSliderValue: 0,
  selectedTransformationType: '',
  selectedShirtColorType: SHIRT_COLOR_TYPES.MAIN,
  scale: 1,
  selectedPart: {
    id: '',
    partType: '',
  },
  faceType: '',
  avatarPartsConfig: {
    hairBack: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    shirt: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: true,
      availableVariations: PART_ACTIONS[PART_TYPES.SHIRT],
      colorKey: defaultColors.shirt.main,
      secondaryColorKey: defaultColors.shirt.second,
    }),
    ears: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: true,
    }),
    faceShape: Object.freeze({
      colorKey: defaultColors.skin,
      id: '',
      hasDefaultSelection: true,
    }),
    eyeShadow: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    facialLinesForehead: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    eyebrows: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      availableActions: PART_ACTIONS[PART_TYPES.EYEBROWS],
      colorKey: defaultColors.hair,
      id: '',
      hasDefaultSelection: true,
    }),
    eyes: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      availableActions: PART_ACTIONS[PART_TYPES.EYES],
      colorKey: defaultColors.eye,
      id: '',
      hasDefaultSelection: true,
      eyeLiner: false,
    }),
    facialLines: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    facialLinesEyes: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    facialLinesCheek: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    facialLinesChin: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
    nose: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      availableActions: PART_ACTIONS[PART_TYPES.NOSE],
      id: null,
      hasDefaultSelection: true,
    }),
    glasses: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: null,
      availableActions: PART_ACTIONS[PART_TYPES.GLASSES],
      hasDefaultSelection: false,
    }),
    mouth: Object.freeze({
      colorKey: defaultColors.mouth,
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      availableActions: PART_ACTIONS[PART_TYPES.MOUTH],
      id: null,
      hasDefaultSelection: true,
    }),
    facialHair: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      colorKey: defaultColors.hair,
      availableActions: PART_ACTIONS[PART_TYPES.FACIAL_HAIR],
      id: '',
      hasDefaultSelection: false,
    }),
    jewelry: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      colorKey: defaultColors.jewelry,
      id: '',
      hasDefaultSelection: false,
    }),
    jewelryEarrings: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      colorKey: defaultColors.jewelry,
      id: '',
      hasDefaultSelection: false,
    }),
    jewelryNecklaces: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      colorKey: defaultColors.jewelry,
      id: '',
      hasDefaultSelection: false,
    }),
    hair: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      colorKey: defaultColors.hair,
      id: '',
      hasDefaultSelection: false,
    }),
    hats: Object.freeze({
      spacingOffset: 0,
      verticalOffset: 0,
      rotation: 0,
      scale: 1,
      id: '',
      hasDefaultSelection: false,
    }),
  },
})

export default initialValues
